module.exports = __webpack_public_path__ + "static/media/schedule.909caef3.svg";